module.exports = __webpack_public_path__ + "static/media/LV3@3x.b7a5a09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/LV/LV3@3x.png
// module id = 680
// module chunks = 0